import React from "react";
import PaymentList from "./PaymentList";
import LanguageList from "./LanguageList";
import { Desktop, Mobile } from "../util/breakpoints";
import Link from "../atoms/Link";

const Links = ({ links }) =>
    links.map((link, index) =>
        <Link className="o-footer-information__link" link={ link } key={ index } />
    );

export default ({ links, organisation }) =>
    <div className="o-footer-information u-tiny-text">
        <Desktop>
            <div className="o-footer-information__col">
                <Links links={ links }/>
            </div>
            <div className="o-footer-information__col">
                <PaymentList/>
                <div className="o-footer-information__row">
                    <p>{ organisation }</p>
                    <div className="o-footer-information__row-item">
                        <LanguageList />
                    </div>
                </div>
            </div>
        </Desktop>
        <Mobile>
            <div className="o-footer-information__col">
                <PaymentList/>
            </div>
            <div className="o-footer-information__col">
                <Links links={ links }/>
            </div>
            <div className="o-footer-information__col">
                <p>{ organisation }</p>
            </div>
            <div className="o-footer-information__col">
                <LanguageList/>
            </div>
        </Mobile>
    </div>;
